<div class="delete-modal-container">
  <div class="delete-header">{{ data.header }}</div>
  <div class="delete-description">{{ data.description }}</div>
  @if (data.expectedValue) {
    <div class="delete-confirm">
      <label for="confirm-input">Type "{{ data.expectedValue }}" to confirm:</label>
      <input id="confirm-input" type="text" [formControl]="confirmControl" [placeholder]="data.expectedValue" autocomplete="off">
    </div>
  }
  <div class="delete-buttons">
    <app-button text="Cancel" class="secondary" (clicked)="cancel()"></app-button>
    <app-button [text]="data.confirmLabel" [class]="canDelete ? 'danger' : 'danger disabled'" (clicked)="confirm()"></app-button>
  </div>
</div>
